exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host label {\n  margin-bottom: 0 !important;\n  color: black;\n  text-transform: none; }\n\n:host .input-error {\n  color: red;\n  display: block;\n  margin: 0;\n  padding: 0;\n  text-align: right; }\n\n:host .form-group {\n  margin-bottom: 12px !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/core/input/input.component.scss
// module id = 906
// module chunks = 0